import { render, staticRenderFns } from "./RulesetSettings.vue?vue&type=template&id=81062302"
import script from "./RulesetSettings.vue?vue&type=script&lang=js"
export * from "./RulesetSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports